import api from "./api";
import { errorHandling } from "./error.handling";
const reportBasePath = `${process.env.REACT_APP_API_BASE_URL}`;
const logBasePath = `${process.env.REACT_APP_API_LOG_BASE_URL}`;

async function fetchJourneyWork(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("DriverId", payload.driverId);
    queryString.append("Extra", "N");
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/journey-summary?${queryString}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/journey-summary?${queryString}`
    );

    console.log("JourneyWorkReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchJourneyWork"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchJourneyWork");
    return null;
  }
}

async function fetchDistanceTravelled(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/distance-traveled?${queryString}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/distance-traveled?${queryString}`
    );

    console.log("DistanceTraveledReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchDistanceTravelled"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchDistanceTravelled");
    return null;
  }
}

async function fetchVehicleActivities(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("Speed", payload.speed);
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/activity-summary?${queryString}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/activity-summary?${queryString}`
    );

    console.log("VehicleActivitiesReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVehiclePositions(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/positions/all?${queryString}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/position?${queryString}`
    );

    console.log("VehicleActivitiesReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVisitsInPeriod(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("GroupId", payload.groupId);
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("TypeReport", payload.fileType);
    queryString.append("EventType", payload.eventType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/vehicle-visit-summary?${queryString}&DurationTime=${payload.durationTime}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/vehicle-visit-summary?${queryString}`
    );

    console.log("VisitsInPeriodReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVisitsInPeriod"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVisitsInPeriod");
    return null;
  }
}

async function fetchVisitsAmount(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("GroupId", payload.groupId);
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("EventType", payload.eventType);
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/vehicle-visit-sequence-summary?${queryString}&DurationTime=${payload.durationTime}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/vehicle-visit-sequence-summary?${queryString}`
    );

    console.log("VisitsAmountReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVisitsAmount"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVisitsAmount");
    return null;
  }
}

async function fetchVehicleProtocols(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateOpen", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);

    const response = await api.get(
      !download
        ? `${reportBasePath}/protocols?${queryString}`
        : `${reportBasePath}/report/protocols?${queryString}`
    );

    console.log("VehicleProtocolsReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleProtocols"
    );
    if (treated) {
      const protocolDetails = await treated.map(async (protocol) => {
        const detail = await fetchVehicleProtocolsDetails(protocol.protocolId);
        return {
          id: protocol.protocolId,
          vehicleId: protocol.vehicleId,
          plate: protocol.plate,
          alert: protocol.alert,
          dateTimeOpen: detail?.dateTimeOpen || "",
          dateTimeService: detail?.dateTimeService || "",
          dateTimeClose: detail?.dateTimeClose || "",
          status: detail?.status || "",
          attendant: detail?.attendant || "",
        };
      });

      const result = await Promise.all(protocolDetails);
      return result;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleProtocols");
    return null;
  }
}

async function fetchVehicleProtocolsDetails(protocolId) {
  try {
    const response = await api.get(
      `${reportBasePath}/protocols/${protocolId}/details`
    );

    console.log("VehicleProtocolsDetailsReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleProtocolsDetails"
    );
    if (treated) {
      let protocolDetail = {
        dateTimeOpen: "",
        dateTimeService: "",
        dateTimeClose: "",
        attendant: "",
        status: "",
      };

      if (!Array.isArray(treated) || treated.length === 0) {
        return protocolDetail;
      }

      const detailRegex =
        /^(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})\s+-\s+(.+)$/;

      treated.forEach((protocol) => {
        if (!protocol?.detail) return;

        const match = protocol.detail.match(detailRegex);
        if (!match) return;

        const [, dateTime, eventType] = match;
        const trimmedEvent = eventType.trim();

        if (trimmedEvent === "Abertura") {
          protocolDetail.dateTimeOpen = dateTime;
        } else if (trimmedEvent === "Alocação do Alerta") {
          protocolDetail.dateTimeService = dateTime;
          protocolDetail.attendant = protocol.userName;
        } else if (trimmedEvent === "Desalocação do Alerta") {
          protocolDetail.dateTimeClose = dateTime;
        }
      });

      if (protocolDetail.dateTimeClose) {
        protocolDetail.status = "FECHADO";
      } else if (protocolDetail.dateTimeService) {
        protocolDetail.status = "EM ATENDIMENTO";
      } else if (protocolDetail.dateTimeOpen) {
        protocolDetail.status = "ABERTO";
      }

      return protocolDetail;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "reportService.fetchVehicleProtocolsDetails"
    );
    return null;
  }
}

async function fetchSpeedControl(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("VehicleId", payload.vehicleId);
    queryString.append("DateStart", payload.dateTimeScheduleStart);
    queryString.append("DateEnd", payload.dateTimeScheduleEnd);
    queryString.append("Speed", payload.speed);
    queryString.append("EventType", payload.eventType);
    queryString.append("TypeReport", payload.fileType);

    const response = await api.get(
      !download
        ? `${reportBasePath}/vehicles/${payload.vehicleId}/vehicle-speed-summary?${queryString}`
        : `${reportBasePath}/vehicles/${payload.vehicleId}/reports/vehicle-speed-summary?${queryString}`
    );

    console.log("VehicleSpeedControlReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchSpeedControl"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchSpeedControl");
    return null;
  }
}

async function fetchSystemLogs(payload, download) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("PageSize", payload.pageSize);
    queryString.append("PageNumber", payload.pageNumber);
    queryString.append("StartDate", payload.dateTimeScheduleStart);
    queryString.append("EndDate", payload.dateTimeScheduleEnd);

    const fileExtension =
      payload.fileType === "pdf"
        ? "pdf"
        : payload.fileType === "xls"
          ? "xls"
          : "pdf"; // fallback

    const response = await api.get(
      !download
        ? `${logBasePath}/logs?${queryString}`
        : `${logBasePath}/logs/reports/log-list/${fileExtension}?${queryString}`
    );


    console.log("VehicleActivitiesReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVehicleGrid(vehicleId, payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${reportBasePath}/vehicles/${vehicleId}/reports?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleGrid"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleGridPositions(vehicleId, payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${reportBasePath}/vehicles/${vehicleId}/reports/position?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleGridPositions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchNearbyVehiclesReport(vehicleId, payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${reportBasePath}/vehicles/${vehicleId}/reports/nearby-summary?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchNearbyVehicles"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

// REVISAR ABAIXO
// async function fetchDetailedVehicleActivities(payload, download) {
//   try {
//     let url = `${reportBasePath}/Vehicle/DetailedVehicleActivity`;

//     if (download)
//       url = `${reportBasePath}/Report/GenerateReport/DetailedVehicleActivity/${payload.fileType}`;

//     console.log(url);

//     let response = await api.post(url, payload);

//     let treated = errorHandling.handleResponse(
//       response,
//       'reportService.fetchVehicleActivities'
//     );
//     if (treated) {
//       return treated;
//     }
//     return null;
//   } catch (error) {
//     errorHandling.cathError(error, 'reportService.fetchVehicleActivities');
//     return null;
//   }
// }

async function list(pageSize, pageNumber) {
  try {
    let url = `${reportBasePath}/Report/${pageSize}/${pageNumber}`;

    let response = await api.get(url);

    console.log("SelectJourneyWorkReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function makeReport(payload) {
  try {
    let url = `${reportBasePath}/Report/makeReportRequest`;

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.fetchVehicleActivities"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.fetchVehicleActivities");
    return null;
  }
}

async function fetchVehicleGridKML(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/KML`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("VehicleGridReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.VehicleGrid"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.VehicleGrid");
    return null;
  }
}

// async function fetchVehicleGridPDF(payload) {
// 	try {
// 		const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/PDF`;

// 		console.log(url);

// 		let response = await api.post(url, payload);

// 		console.log("VehicleGridReport", response);

// 		let treated = errorHandling.handleResponse(
// 			response,
// 			"reportService.VehicleGrid"
// 		);
// 		if (treated) {
// 			return treated;
// 		}
// 		return null;
// 	} catch (error) {
// 		errorHandling.cathError(error, "reportService.VehicleGrid");
// 		return null;
// 	}
// }

async function fetchVehicleGridXLS(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/VehicleGrid/XLS`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("VehicleGridReport", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.VehicleGrid"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.VehicleGrid");
    return null;
  }
}

async function fetchVehiclePositionsXLS(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/XLS`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

async function fetchVehiclePositionsKML(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/KML`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

async function fetchVehiclePositionsPDF(payload) {
  try {
    const url = `${reportBasePath}/Report/GenerateReport/Positions/PDF`;

    console.log(url);

    let response = await api.post(url, payload);

    console.log("Positions", response);

    let treated = errorHandling.handleResponse(
      response,
      "reportService.Positions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "reportService.Positions");
    return null;
  }
}

export const reportService = {
  fetchJourneyWork,
  fetchDistanceTravelled,
  fetchVehicleActivities,
  fetchVehiclePositions,
  fetchVisitsInPeriod,
  fetchVisitsAmount,
  fetchVehicleProtocols,
  fetchSpeedControl,
  fetchSystemLogs,
  fetchVehicleGrid,
  fetchVehicleGridPositions,
  fetchNearbyVehiclesReport,
  // Revisar abaixo
  fetchVehicleGridKML,
  fetchVehicleGridXLS,
  fetchVehiclePositionsXLS,
  fetchVehiclePositionsKML,
  fetchVehiclePositionsPDF,
  // fetchDetailedVehicleActivities,
  list,
  makeReport,
};
